// Mock data for Zamzam Umrah Builder website
// UMRAH-ONLY PLATFORM - No flights

export const packages = [
  {
    id: 1,
    name: "Economy Umrah",
    image: "https://images.pexels.com/photos/2895295/pexels-photo-2895295.jpeg?auto=compress&cs=tinysrgb&w=800",
    duration: "10 Days / 9 Nights",
    mecca: {
      hotel: "Dar Al Eiman Grand",
      stars: 4,
      roomType: "QUAD SHARING",
      nights: 5,
      distance: "200 M To Masjidil Haram"
    },
    medina: {
      hotel: "Dar Al Eiman Taiba",
      stars: 4,
      roomType: "QUAD SHARING",
      nights: 4,
      distance: "200 M To Masjid Nabawi"
    },
    includes: ["Umrah Visa", "Hotel Accommodation", "Airport Transfers", "Ziyarat Tours"],
    originalPrice: "1,299",
    currentPrice: "999",
    currency: "GBP",
    booked: 100,
    total: 150
  },
  {
    id: 2,
    name: "Standard Umrah",
    image: "https://images.pexels.com/photos/3890524/pexels-photo-3890524.jpeg?auto=compress&cs=tinysrgb&w=800",
    duration: "14 Days / 13 Nights",
    mecca: {
      hotel: "Pullman ZamZam",
      stars: 5,
      roomType: "TRIPLE SHARING",
      nights: 7,
      distance: "50 M To Masjidil Haram"
    },
    medina: {
      hotel: "Anwar Al Madinah",
      stars: 5,
      roomType: "TRIPLE SHARING",
      nights: 6,
      distance: "100 M To Masjid Nabawi"
    },
    includes: ["Umrah Visa", "5-Star Hotels", "VIP Transfers", "Ziyarat Tours", "Breakfast"],
    originalPrice: "1,899",
    currentPrice: "1,499",
    currency: "GBP",
    booked: 85,
    total: 120
  },
  {
    id: 3,
    name: "Ramadan Umrah",
    image: "https://images.pexels.com/photos/2406731/pexels-photo-2406731.jpeg?auto=compress&cs=tinysrgb&w=800",
    duration: "21 Days / 20 Nights",
    mecca: {
      hotel: "Fairmont Clock Tower",
      stars: 5,
      roomType: "DOUBLE SHARING",
      nights: 14,
      distance: "Direct Access to Haram"
    },
    medina: {
      hotel: "Oberoi Madinah",
      stars: 5,
      roomType: "DOUBLE SHARING",
      nights: 6,
      distance: "50 M To Masjid Nabawi"
    },
    includes: ["Umrah Visa", "Luxury Hotels", "Private Transfers", "All Meals", "Guide"],
    originalPrice: "3,999",
    currentPrice: "3,499",
    currency: "GBP",
    booked: 45,
    total: 60
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Economy",
    price: "999",
    currency: "GBP",
    period: "Person",
    color: "#1a365d",
    description: "Perfect for budget-conscious pilgrims",
    features: [
      { name: "Umrah Visa Processing", included: true },
      { name: "4-Star Hotel Makkah", included: true },
      { name: "4-Star Hotel Madinah", included: true },
      { name: "Airport Transfers", included: true },
      { name: "Ziyarat Tours", included: false },
      { name: "Breakfast Included", included: false },
      { name: "24/7 Guide Support", included: false }
    ]
  },
  {
    id: 2,
    name: "Standard",
    price: "1,499",
    currency: "GBP",
    period: "Person",
    color: "#d69e2e",
    featured: true,
    description: "Most popular choice for families",
    features: [
      { name: "Umrah Visa Processing", included: true },
      { name: "5-Star Hotel Makkah", included: true },
      { name: "5-Star Hotel Madinah", included: true },
      { name: "VIP Airport Transfers", included: true },
      { name: "Ziyarat Tours", included: true },
      { name: "Breakfast Included", included: true },
      { name: "24/7 Guide Support", included: false }
    ]
  },
  {
    id: 3,
    name: "Premium",
    price: "2,499",
    currency: "GBP",
    period: "Person",
    color: "#2d3748",
    description: "Ultimate luxury Umrah experience",
    features: [
      { name: "Umrah Visa Processing", included: true },
      { name: "5-Star Luxury Hotel Makkah", included: true },
      { name: "5-Star Luxury Hotel Madinah", included: true },
      { name: "Private Luxury Transfers", included: true },
      { name: "Private Ziyarat Tours", included: true },
      { name: "All Meals Included", included: true },
      { name: "Personal Guide 24/7", included: true }
    ]
  }
];

export const services = [
  {
    id: 1,
    icon: "hotel",
    title: "Premium Hotels",
    description: "Hand-picked hotels in Makkah & Madinah, steps away from the holy mosques."
  },
  {
    id: 2,
    icon: "support",
    title: "24/7 Support",
    description: "Dedicated pilgrim support throughout your spiritual journey."
  },
  {
    id: 3,
    icon: "transport",
    title: "Ground Transport",
    description: "Comfortable transfers between airports, hotels, and holy sites."
  },
  {
    id: 4,
    icon: "visa",
    title: "Visa Services",
    description: "Hassle-free Umrah visa processing with expert guidance."
  }
];

// UK Departure Cities (No flights - just for package origin)
export const departureCities = [
  "London",
  "Manchester",
  "Birmingham",
  "Edinburgh",
  "Glasgow",
  "Bristol",
  "Leeds",
  "Newcastle",
  "Cardiff",
  "Belfast"
];

export const nightOptions = ["3 Nights", "5 Nights", "7 Nights", "10 Nights", "14 Nights", "21 Nights"];

export const accommodationOptions = ["Economy (4-Star)", "Standard (5-Star)", "Deluxe (5-Star)", "Premium (Luxury)"];

export const roomTypes = ["Quad Sharing", "Triple Sharing", "Double Sharing", "Single Room"];

export const navigation = [
  { name: "HOME", href: "#home" },
  { name: "UMRAH PACKAGES", href: "#packages" },
  { name: "BUILD YOUR UMRAH", href: "#builder" },
  { name: "SERVICES", href: "#services" },
  { name: "ABOUT US", href: "#about" },
  { name: "CONTACT US", href: "#contact" }
];

export const contactInfo = {
  phone: "01582 800 304",
  whatsapp: "+44 7404 386262",
  email: "info@zamzamumrah.co.uk",
  bookings: "bookings@zamzamumrah.co.uk",
  address: "123 High Street, London, UK",
  workingHours: "08:00 AM – 12:00 Midnight",
  closedDays: "7 Days a Week"
};

export const socialLinks = [
  { name: "Facebook", icon: "facebook", url: "#" },
  { name: "Twitter", icon: "twitter", url: "#" },
  { name: "Instagram", icon: "instagram", url: "#" },
  { name: "LinkedIn", icon: "linkedin", url: "#" }
];

export const brandInfo = {
  name: "Zamzam Umrah Builder",
  shortName: "Zamzam Umrah",
  tagline: "Build Your Perfect Umrah Journey",
  description: "Your trusted partner for customized Umrah packages. Build, customize, and book your spiritual journey to the holy cities of Makkah and Madinah."
};
